import React, {FC, useEffect, useState} from "react";
import {ActionTypeEnum, RequestActionModel, TransactionItemResponseModel} from "../../models";
import {getLabelName, isArabicCurrentLanguage} from "../../utils";
import {
    beneficiaryCancelSearchBtnStyle,
    beneficiaryCloseSearchModelBtnStyle,
    beneficiaryInfoButtonStyle,
    beneficiarySearchBtnStyle,
    beneficiarySearchTextBoxStyle,
} from "../transactions/common/css/posCss";
import {getPosItemList} from "../transactions/common/businessLogic/posTransactionBl";
import {ButtonBox, LoadingBox, TextBox} from "..";

export const ItemButtonList: FC<{ onActionEvent: (o: RequestActionModel) => void }> = ({
                                                                                      onActionEvent = () => {
                                                                                      }
                                                                                  }) => {
    //#region variables
    const isArabic = isArabicCurrentLanguage();
    const [buttonWidth, setButtonWidth] = useState("190px");
    //#endregion
    //#region state
    const [loading, setLoading] = useState(false);
    const [filterText, setFilterText] = useState<string | null>(null);
    const [items, setItems] = useState<TransactionItemResponseModel[]>([]);
    //#endregion
    //#region functions
    const handleSortAlphabetically = (list: TransactionItemResponseModel[], isArabic: boolean): TransactionItemResponseModel[] => {
        return list.slice().sort((a, b) => {
            const propertyName = isArabic ? "ItemName_En" : "ItemName";
            const nameA = a[propertyName].toUpperCase();
            const nameB = b[propertyName].toUpperCase();
            if (nameA < nameB) {
                return -1;
            }
            if (nameA > nameB) {
                return 1;
            }
            return 0;
        });
    };
    const handleSearch = async (isClearSearch: boolean = false, searchText: string | null = null) => {
        setLoading(true);
        let lowerQuery: string | null = !isClearSearch ? (searchText || filterText || "").toLowerCase() : "";
        lowerQuery = lowerQuery === "" ? null : lowerQuery;
        let responseResult = await getPosItemList(null, null, lowerQuery, null);
        responseResult = handleSortAlphabetically(responseResult, isArabic);
        setItems(responseResult);
        setLoading(false);
    }
    //#endregion
    //#region useEffect
    useEffect(() => {
        const updateLayout = () => {
            const width = window.innerWidth;
            if (width < 600) {
                // setRowPattern([2]);
                setButtonWidth("150px");  // أصغر زر
            } else if (width >= 600 && width < 1000) {
                //setRowPattern([3]);
                setButtonWidth("130px"); // حجم متوسط أصغر شوي
            } else if (width >= 1000 && width < 1200) {
                //setRowPattern([4]);
                setButtonWidth("170px"); // حجم متوسط
            } else {
                //setRowPattern([5]);
                setButtonWidth("190px");  // الحجم الكبير الأصلي
            }
        };
        updateLayout();
        window.addEventListener("resize", updateLayout);

        return () => window.removeEventListener("resize", updateLayout);
    }, []);

    //#endregion
    //#region html
    return (<>
        {loading && <LoadingBox/>}
        <div
            className="d-flex flex-wrap justify-content-center align-items-center gap-2 mx-auto"
            style={{
                width: "100%",
                maxWidth: "1000px",
            }}
        >
            <TextBox
                labelName={getLabelName("")} //{t("lookup.nameAr")}
                inputName={"filterTextBox"}
                inputValue={filterText}
                onChange={async (e: any) => {
                    const searchText: string | null = (e.target.value && e.target.value.length < 3) ? null : e.target.value;
                    setFilterText(e.target.value)
                    if (searchText !== null) {
                        await handleSearch(false, searchText);
                    }
                }}
                style={beneficiarySearchTextBoxStyle}
                controlSize="w-25"
            />
            <ButtonBox
                //iconType="magnify"
                type="submit"
                className="btn mx-2"
                variant=""
                onClick={async () => {
                    await handleSearch();
                }}
                style={beneficiarySearchBtnStyle}
            >
                {getLabelName("Search")}
            </ButtonBox>
            <ButtonBox
                //iconType="close-circle"
                type="button"
                className="btn mx-2"
                variant=""
                onClick={async () => {
                    setFilterText('')
                    await handleSearch(true);
                }}
                style={beneficiaryCancelSearchBtnStyle}
            >
                {getLabelName("Cancel")}
            </ButtonBox>
            <ButtonBox
                //iconType="close-circle"
                type="button"
                className="btn mx-2"
                variant=""
                onClick={async () => {
                    onActionEvent({
                        action: ActionTypeEnum.None
                    })
                }}
                style={beneficiaryCloseSearchModelBtnStyle}
            >
                {getLabelName("Close")}
            </ButtonBox>
        </div>
        <ul className="align-items-start align-content-start d-flex flex-wrap pos-list  p-2">
            {items !== null &&
                items.length !== 0 &&
                items.map((row, index) => (
                    <li className="list-group-item p-1 w-auto border-0" key={index}>
                        <ButtonBox
                            key={`item_btn_${index}`}
                            variant="light"
                            className="shadow-sm border-0 fw-semibold"
                            style={{...beneficiaryInfoButtonStyle ,width: buttonWidth}}
                            id={`item_btn_${index}`}
                            onClick={() => {
                                onActionEvent({
                                    action: ActionTypeEnum.SelectItemResponse,
                                    request: row
                                })
                            }}
                        >
                            {isArabic ? row.ItemName : row.ItemName_En}
                        </ButtonBox>
                    </li>
                ))}
        </ul>
    </>)
    //#endregion
}